import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import CommandCenter from '@/components/foundation/command_center.vue'

export default class extends Controller {
  static values = {
    payload: Object
  }

  connect() {
    this.vue = createApp(CommandCenter, {
      payload: this.payloadValue || {}
    })

    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
